/* cb'dé product card — interactions globales (variant pick, wishlist, AJAX add). Skip .cbde-section-collection-grid (gere par son JS inline). */

(function(){
  var root = document;
  

  function fmt(s){
    // s is already a money-formatted string from Liquid; we just return it.
    return s;
  }
  function computeDiscount(price, compare){
    if (!compare || compare <= price) return 0;
    return Math.round((compare - price) * 100 / compare);
  }
  function formatPerGram(price, grams, currency){
    var ppg = price / grams;
    return ppg.toFixed(2).replace('.', ',') + currency + '/g';
  }

  // === VARIANT CLICK : reveal price + relabel button ===
  root.querySelectorAll('.cbde-tile').forEach(function(tile){
    if (tile.closest('.cbde-section-collection-grid')) return;
    if (tile.dataset.cbdeInit) return; tile.dataset.cbdeInit='1';
    var variants = tile.querySelectorAll('.cbde-tile-variant:not(.is-sold)');
    var fromEl = tile.querySelector('[data-cbde-from]');
    var priceRow = tile.querySelector('[data-cbde-price-row]');
    var priceEl = tile.querySelector('[data-cbde-price]');
    var oldEl = tile.querySelector('[data-cbde-old]');
    var discEl = tile.querySelector('[data-cbde-discount]');
    var ppgEl = tile.querySelector('[data-cbde-ppg]');
    var vidInput = tile.querySelector('[data-cbde-vid]');
    var addBtn = tile.querySelector('[data-cbde-add]');
    var btnLabel = tile.querySelector('[data-cbde-btn-label]');

    variants.forEach(function(v){
      v.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        variants.forEach(function(x){ x.classList.remove('is-active'); x.setAttribute('aria-checked','false'); });
        v.classList.add('is-active');
        v.setAttribute('aria-checked','true');

        var price = parseFloat(v.dataset.price);
        var compare = v.dataset.compare ? parseFloat(v.dataset.compare) : null;
        var grams = v.dataset.grams ? parseFloat(v.dataset.grams) : null;

        // Hide "À partir de", reveal price row
        if (fromEl) fromEl.style.display = 'none';
        if (priceRow) priceRow.style.display = '';

        if (priceEl) priceEl.textContent = v.dataset.priceDisplay || (price.toFixed(2).replace('.', ',') + ' €');

        if (oldEl) {
          if (compare && compare > price) {
            oldEl.textContent = v.dataset.compareDisplay || (compare.toFixed(2).replace('.', ',') + ' €');
            oldEl.style.display = '';
          } else {
            oldEl.style.display = 'none';
          }
        }
        if (discEl) {
          var d = computeDiscount(price, compare);
          if (d > 0) {
            discEl.textContent = '-' + d + '%';
            discEl.style.display = '';
          } else {
            discEl.style.display = 'none';
          }
        }
        if (ppgEl && grams > 0) {
          var currency = (v.dataset.priceDisplay || '€').replace(/[\d\s,.]/g, '').slice(-1) || '€';
          ppgEl.style.display = '';
          ppgEl.innerHTML = "Soit" + ' <strong>' + formatPerGram(price, grams, ' ' + currency) + '</strong>';
        }
        if (vidInput) vidInput.value = v.dataset.vid;
        if (addBtn) {
          addBtn.disabled = false;
          if (btnLabel) btnLabel.textContent = "Ajouter";
        }
      });
    });

    // === WISHLIST TOGGLE (purely visual, persist in localStorage) ===
    var wishlist = tile.querySelector('[data-cbde-wishlist]');
    if (wishlist) {
      var handle = tile.dataset.cbdeHandle;
      try {
        var saved = JSON.parse(localStorage.getItem('cbde_wishlist_v1') || '[]');
        if (saved.indexOf(handle) >= 0) wishlist.classList.add('is-saved');
      } catch(e){}
      wishlist.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var on = wishlist.classList.toggle('is-saved');
        try {
          var s = JSON.parse(localStorage.getItem('cbde_wishlist_v1') || '[]');
          var i = s.indexOf(handle);
          if (on && i < 0) s.push(handle);
          if (!on && i >= 0) s.splice(i, 1);
          localStorage.setItem('cbde_wishlist_v1', JSON.stringify(s));
        } catch(e){}
      });
    }
  });

  // === AJAX ADD-TO-CART ===
  
  root.querySelectorAll('[data-cbde-form]').forEach(function(form){
    if (form.closest('.cbde-section-collection-grid')) return;
    if (form.dataset.cbdeFormInit) return; form.dataset.cbdeFormInit='1';
    form.addEventListener('submit', function(e){
      /* 🧨 Certaines sections (fiche produit, slider produits) posent DÉJÀ leur propre
         gestionnaire sur ce formulaire. Les deux postaient /cart/add.js pour un seul
         clic, et Shopify ne sérialise pas ces appels : une fois sur trois le panier
         retenait 2 articles au lieu d'1, et le client payait le double.
         Tous ces gestionnaires commencent par preventDefault(), et le script inline
         d'une section s'exécute avant cet asset : si l'envoi est déjà pris, on s'efface.
         Là où ce gestionnaire est seul (tuiles de collection, recherche), rien ne change. */
      if (e.defaultPrevented) return;
      e.preventDefault();
      var fd = new FormData(form);
      var btn = form.querySelector('[data-cbde-add]');
      var lbl = form.querySelector('[data-cbde-btn-label]');
      var origText = lbl ? lbl.textContent : '';
      if (lbl) lbl.textContent = '...';
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', {
        method:'POST', body:fd,
        headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/javascript'}
      }).then(function(r){ return r.json(); }).then(function(data){
        if (lbl) lbl.textContent = "✓ Ajouté";
        document.dispatchEvent(new CustomEvent('cbde:cart:added', {detail: data}));
        if (window.theme && typeof window.theme.openCart === 'function') window.theme.openCart();
        else document.dispatchEvent(new CustomEvent('cart:open'));
        setTimeout(function(){
          if (lbl) lbl.textContent = origText;
          if (btn) btn.disabled = false;
        }, 1800);
      }).catch(function(){
        if (lbl) lbl.textContent = "Erreur";
        setTimeout(function(){
          if (lbl) lbl.textContent = origText;
          if (btn) btn.disabled = false;
        }, 1800);
      });
    });
  });
  
})();
